import React from 'react';

interface ConnectorToggleProps {
  value: 'ANY' | 'ALL';
  onChange: (value: 'ANY' | 'ALL') => void;
  className?: string;
}

const options = [
  { label: 'Any', value: 'ANY' as const },
  { label: 'All', value: 'ALL' as const },
];

const ConnectorToggle: React.FC<ConnectorToggleProps> = ({
  value,
  onChange,
  className = '',
}) => {
  return (
    <div
      className="px-3 py-2 border-b border-neutral-200"
      data-testid="provider-connector-section"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs text-neutral-600">Match:</span>

        <div className={`inline-flex flex-col gap-1 w-32 ${className}`}>
          <div className="relative w-full h-full select-none">
            {/* Background pill */}
            <div className="absolute inset-0 bg-level-2 rounded-full" />
            {/* Active pill */}
            <div
              className="absolute top-0 bottom-0 w-1/2 transition-all duration-300 rounded-full bg-sky-600 shadow-xl z-10"
              style={{
                left: value === 'ANY' ? '0%' : '50%',
              }}
            />
            <div className="relative flex w-full h-full z-20">
              {options.map((option) => (
                <div key={option.value} className="relative flex-1">
                  <button
                    type="button"
                    className={`w-full h-full flex items-center justify-center py-1 px-4 transition-colors duration-300 cursor-pointer rounded-full text-sm leading-tight focus:outline-none ${
                      value === option.value
                        ? 'text-white font-bold'
                        : 'text-secondary font-normal'
                    }`}
                    aria-pressed={value === option.value}
                    onClick={() => onChange(option.value)}
                    tabIndex={0}
                    style={{ minWidth: 0, zIndex: 30 }}
                  >
                    {option.label}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectorToggle;
